<script>
import axios from "axios";

import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
import { mapState } from "vuex";

import { required, email, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import Loader from "@/router/views_mobagile/components/loader.vue";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

/**
 * Register component
 */
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  page: {
    title: "Registrar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
  },
  data() {
    return {
      user: {
        name: "",
        email: "",
        password: "",
      },
      submitted: false,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      registerSuccess: false,
      cadastraConta: true,
      errosValid: null,
      updating: false,
      showModalAcceptedTerms: false,
      acceptedTerms: false,
      finishScroll: false
    };
  },
  validations: {
    user: {
      name: {
        required: helpers.withMessage("Nome de usuário obrigatório, favor preencher.", required),
      },
      email: {
        required: helpers.withMessage("E-mail obrigatório, favor preencher.", required),
        email: helpers.withMessage("Favor preencher com endereço de e-mail válido.", email),
      },
      password: {
        required: helpers.withMessage("Senha obrigatória, favor preencher.", required),
      },
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  mounted() {
    console.log('Absolute:', window.location.href);
    if (window.location.href.includes('localhost')
         || (window.location.href.includes('escala25.vercel.app'))
         || (window.location.href.includes('retomada-sigma.vercel.app'))
    ) {
      this.cadastraConta = false
    }
    // this.user.name = "usuario novo"
    // this.user.email = "usuario novo"
    // this.user.password = "abcd123456!!##RFDS"

  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to register the user in with the email, name
    // and password they provided.
    tryToRegisterIn() {
      console.log('tryToRegisterIn')
      this.submitted = true;
      // stop here if form is invalid
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      } else {

        if(this.acceptedTerms === false) {
          this.showModalAcceptedTerms = true;
        } else {
          this.confirmAccepted()
        }
      }
    },

    confirmAccepted() {
      console.log('Confirmou Aceite de Termo de Uso')
      if (this.acceptedTerms === false) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Aceite obrigatório",
          text: "Para continuar, é necessário aceitar os Termos de Uso da plataforma.",
          showConfirmButton: false,
          timer: 3500,
        })
      } else {
        this.showModalAcceptedTerms = false
        this.updating = true
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          this.tryingToRegister = true;
          // Reset the regError if it existed.
          this.regError = null;
          return (
              this.register({
                name: this.user.name,
                email: this.user.email,
                password: this.user.password,
              })
                  // eslint-disable-next-line no-unused-vars
                  .then((token) => {
                    this.tryingToRegister = false;
                    this.isRegisterError = false;
                    this.registerSuccess = true;
                    if (this.registerSuccess) {
                      this.$router.push(
                          this.$route.query.redirectFrom || {
                            name: "default",
                          }
                      );
                    }
                  })
                  .catch((error) => {
                    this.tryingToRegister = false;
                    this.regError = error ? error : "";
                    this.isRegisterError = true;
                  })
          );
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
          const {email, name, password} = this.user;
          if (email && name && password) {
            this.registeruser(this.user);
          }
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "authapi") {
          axios
              .post(`${getBaseUrl()}api/regnovouser`, {
                name: this.user.name,
                email: this.user.email,
                password: this.user.password,
              }).then((res) => {
            console.log('res_tryToRegisterIn')
            console.log(res)
            if (res.data['message'] === 'usuario_criado_sucesso') {
              console.log('redirecionar_boas_vindas')
              let token = res.data['accessToken']
              let nome = res.data['userData']['name']
              let tipo = res.data['userData']['tipo']
              let menus = res.data['menus']

              localStorage.setItem('user', JSON.stringify({
                "id": res.data['userData']['id'],
                "email": res.data['userData']['email'],
                "nome": nome,
                "tipo": tipo,
                "menus": menus,
                "token": token
              }));

              localStorage.setItem('emprconf', JSON.stringify({
                'cnpj': res.data['empreatu']['cnpj'],
                'nome': res.data['empreatu']['fantasia'],
                'layout': res.data['empreatu']['layout'],
                'width': res.data['empreatu']['width'],
                'sidebar': res.data['empreatu']['sidebar'],
                'logow': res.data['empreatu']['logow'],
                'logob': res.data['empreatu']['logob'],
                'regtrib': res.data['empreatu']['regtrib'],
              }))

              this.$router.push('/dashboard/fretes')

            }
            return res;
          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.errosValid = listaErros
            this.updating = false
            this.activeTab = 0
          })
        }
      }
    },

    checkScroll() {
      const el = this.$refs.termsContainer
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
        this.finishScroll = true
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Nova Conta Econopro</h5>
                  <p>Crie agora mesmo sua conta e experimente a plataforma.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img
                      src="@/assets/images/logo.svg"
                      alt
                      class="rounded-circle"
                      height="34"
                    />
                  </span>
                </div>
              </router-link>
            </div>

            <Loader v-if="updating" style="min-height: 200px;">
            </Loader>


            <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
              <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
              favor ajustar e tentar novamente.
            </b-alert>


            <b-alert
              v-model="registerSuccess"
              class="mt-3"
              variant="success"
              dismissible
              >Registration successfull.</b-alert
            >

            <b-alert
              v-model="isRegisterError"
              class="mt-3"
              variant="danger"
              dismissible
              >{{ regError }}</b-alert
            >

            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2" @submit.prevent="tryToRegisterIn">
              <b-form-group
                class="mb-3"
                id="email-group"
                label="Nome de usuário"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="user.name"
                  type="text"
                  placeholder="Nome de usuário"
                  :class="{
                    'is-invalid': submitted && v$.user.name.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && v$.user.name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.user.name.required.$message">{{
                    v$.user.name.required.$message
                  }}</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="fullname-group"
                label="E-mail"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="user.email"
                  type="email"
                  placeholder="Endereço de e-mail"
                  :class="{
                    'is-invalid': submitted && v$.user.email.$error,
                  }"
                ></b-form-input>
                <div
                  v-for="(item, index) in v$.user.email.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="item.$message">{{ item.$message }}</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="password-group"
                label="Senha"
                label-for="password"
              >
                <b-form-input
                  id="password"
                  v-model="user.password"
                  type="password"
                  placeholder="Senha"
                  :class="{
                    'is-invalid': submitted && v$.user.password.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && v$.user.password.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.user.password.required.$message">{{
                    v$.user.password.required.$message
                  }}</span>
                </div>
              </b-form-group>

              <div v-if="acceptedTerms === true" class="mt-4 d-grid">
                <b-button
                    :disabled="cadastraConta"
                    type="submit"
                    variant="primary"
                    class="btn-block"
                >
                  Criar Nova Conta
                </b-button>
              </div>

              <div v-else class="mt-4 d-grid">
                <b-button
                    :disabled="cadastraConta"
                    type="submit"
                    variant="primary"
                    class="btn-block"
                >
                  Criar Nova Conta
                </b-button>
              </div>

<!--              <div class="mt-4 text-center">-->
<!--                <h5 class="font-size-14 mb-3">Sign up using</h5>-->

<!--                <ul class="list-inline">-->
<!--                  <li class="list-inline-item">-->
<!--                    <a-->
<!--                      href="javascript: void(0);"-->
<!--                      class="-->
<!--                        social-list-item-->
<!--                        bg-primary-->
<!--                        text-white-->
<!--                        border-primary-->
<!--                      "-->
<!--                    >-->
<!--                      <i class="mdi mdi-facebook"></i>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                  <li class="list-inline-item">-->
<!--                    <a-->
<!--                      href="javascript: void(0);"-->
<!--                      class="social-list-item bg-info text-white border-info"-->
<!--                    >-->
<!--                      <i class="mdi mdi-twitter"></i>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                  <li class="list-inline-item">-->
<!--                    <a-->
<!--                      href="javascript: void(0);"-->
<!--                      class="-->
<!--                        social-list-item-->
<!--                        bg-danger-->
<!--                        text-white-->
<!--                        border-danger-->
<!--                      "-->
<!--                    >-->
<!--                      <i class="mdi mdi-google"></i>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </div>-->

              <div class="mt-4 text-center">
                <p class="mb-0">
                  Confirmando seu registro estará de acordo com nossos
                  <a href="javascript: void(0);" class="text-primary"
                    >Termos de Uso</a
                  >
                </p>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            Já possui uma conta?
            <router-link to="/login" class="fw-medium text-primary"
              >Login</router-link
            >
          </p>
          <p>
            © {{ new Date().getFullYear() }} <i class="mdi mdi-rocket-launch"></i>  Econopro.

          </p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->


    <b-modal title="Aceite de Termo de Uso da Plataforma" size="lg" v-model="showModalAcceptedTerms" centered hide-footer>

      <div class="terms-container mb-3" ref="termsContainer" @scroll="checkScroll">
        <div class="container">
          <header class="mb-2">
            <h3>TERMO DE USO DA PLATAFORMA <strong>econoPRO</strong></h3>
            <div>Última atualização: {{ new Date().toLocaleDateString() }}</div>
          </header>

          <section>
            <p>
              Bem-vindo(a) à <strong>econoPRO</strong>, sistema de gestão de transportes (TMS)
              desenvolvido para otimizar a operação logística, facilitar o gerenciamento de fretes
              e apoiar a tomada de decisão estratégica de empresas contratantes e parceiros.
            </p>
            <p>
              Ao acessar e utilizar a plataforma, o Usuário declara que leu, compreendeu
              e concorda integralmente com os termos e condições abaixo.
            </p>
          </section>

          <ol class="block">
            <li>
              <div class="title">1. OBJETO</div>
              <div class="clause">
                <p>1.1 Descrição do objeto...</p>
              </div>
            </li>
            <li>
              <div class="title">2. CADASTRO E ACESSO</div>
              <div class="clause">
                <p>2.1 O acesso à econoPRO é restrito a usuários previamente cadastrados pela empresa contratante.</p>
                <p>2.2 O Usuário é responsável por fornecer informações verdadeiras, completas e atualizadas no momento do cadastro.</p>
                <p>2.3 As credenciais de acesso (login e senha) são pessoais e intransferíveis, sendo de responsabilidade exclusiva do Usuário mantê-las em sigilo.</p>
              </div>
            </li>

            <li>
              <div class="title">3. RESPONSABILIDADES DO USUÁRIO</div>
              <div class="clause">
                <p>3.1 Utilizar a plataforma de forma lícita, ética e em conformidade com a legislação vigente.</p>
                <p>3.2 Não compartilhar informações sigilosas obtidas por meio da econoPRO com terceiros não autorizados.</p>
                <p>3.3 Zelar pela veracidade dos dados inseridos no sistema (ex.: tabelas de frete, documentos de transporte, XMLs de CT-e).</p>
                <p>3.4 Responsabilizar-se por qualquer operação realizada sob seu login e senha.</p>
              </div>
            </li>

            <li>
              <div class="title">4. RESPONSABILIDADES DA CONTRATADA</div>
              <div class="clause">
                <p>4.1 Disponibilizar o acesso à econoPRO conforme contratado, com níveis adequados de segurança, estabilidade e suporte técnico.</p>
                <p>4.2 Proteger os dados armazenados contra acessos não autorizados, utilizando boas práticas de segurança da informação.</p>
                <p>4.3 Realizar manutenções periódicas, podendo suspender temporariamente o acesso em caso de atualizações, ajustes técnicos ou força maior, comprometendo-se a comunicar previamente sempre que possível.</p>
              </div>
            </li>

            <li>
              <div class="title">5. LIMITAÇÕES DE RESPONSABILIDADE</div>
              <div class="clause">
                <p>5.1 A Contratada não se responsabiliza por:</p>
                <div class="sub">
                  <p>- Decisões comerciais tomadas com base em relatórios e informações geradas pela econoPRO;</p>
                  <p>- Indisponibilidades ocasionadas por falhas de terceiros (ex.: operadoras de internet, servidores externos, integrações com ERPs e sistemas governamentais);</p>
                  <p>- Erros decorrentes de informações incorretas inseridas pelo Usuário.</p>
                </div>
              </div>
            </li>

            <li>
              <div class="title">6. PROPRIEDADE INTELECTUAL</div>
              <div class="clause">
                <p>6.1 Todos os direitos sobre a econoPRO, incluindo códigos, interface, design, logotipos, relatórios e funcionalidades, pertencem exclusivamente à Contratada.</p>
                <p>6.2 É vedada a reprodução, modificação, distribuição ou comercialização de qualquer parte da plataforma sem autorização expressa e por escrito da Contratada.</p>
              </div>
            </li>

            <li>
              <div class="title">7. PRIVACIDADE E PROTEÇÃO DE DADOS</div>
              <div class="clause">
                <p>7.1 A Contratada compromete-se a tratar os dados em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 - LGPD).</p>
                <p>7.2 Os dados inseridos na econoPRO pertencem exclusivamente à empresa contratante, sendo a Contratada apenas operadora/gestora do sistema.</p>
                <p>7.3 O uso dos dados será restrito à execução dos serviços contratados, vedado o compartilhamento indevido com terceiros.</p>
              </div>
            </li>

            <li>
              <div class="title">8. VIGÊNCIA E RESCISÃO</div>
              <div class="clause">
                <p>8.1 O presente Termo permanecerá válido enquanto durar a relação contratual entre a Contratada e a empresa contratante.</p>
                <p>8.2 O descumprimento das disposições aqui estabelecidas poderá acarretar suspensão ou cancelamento do acesso do Usuário.</p>
              </div>
            </li>

            <li>
              <div class="title">9. ALTERAÇÕES DOS TERMOS</div>
              <div class="clause">
                <p>9.1 A Contratada poderá modificar este Termo a qualquer momento, comprometendo-se a comunicar os Usuários sobre alterações relevantes.</p>
                <p>9.2 O uso contínuo da econoPRO após a atualização dos termos será considerado como aceitação tácita das novas condições.</p>
              </div>
            </li>

            <li>
              <div class="title">10. LEI APLICÁVEL E FORO</div>
              <div class="clause">
                <p>10.1 Este Termo será regido pelas leis brasileiras.</p>
                <p>10.2 As partes elegem o foro da comarca de Serra - ES, com renúncia de qualquer outro, por mais privilegiado que seja, para dirimir eventuais controvérsias decorrentes deste Termo.</p>
              </div>
            </li>
          </ol>

          <footer>
            <div class="company-info">
              <strong>econoCargo</strong><br>
              CNPJ: 27.174.661/0001-90<br>
              Telefone: (27) 3020-7888<br>
              E-mail: econocargo.e@gmail.com
            </div>
          </footer>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-baseline">
        <input id="accepted"
               v-model="acceptedTerms"
               type="checkbox"
               class="form-check-input me-2 custom-checkbox"
        />
        <label for="accepted" class="form-check-label text-dark">Li e aceito os Termos de Uso</label>
      </div>
      <div class="d-flex justify-content-center mb-3">
        <p>
          © {{ new Date().getFullYear() }} <i class="mdi mdi-rocket-launch"></i>  Econopro.
        </p>
      </div>

      <div class="d-flex justify-content-center mb-2">
        <b-button title="Excluir Etiquetas"
                  variant="outline-primary"
                  size="md"
                  class="px-2 mx-3"
                  @click="showModalAcceptedTerms = false"
        >
          <i class="bx bx-block font-size-16 align-middle me-1"></i>
          <span class="small">Cancelar</span>
        </b-button>

        <b-button title="Confirmar Volumes"
                  type="submit"
                  variant="success"
                  size="md"
                  class="px-2 mx-3"
                  :disabled="!finishScroll"
                  @click="confirmAccepted"
        >
          <i class="bx bx-check-double font-size-16 align-middle mx-2"></i>
          <span class="small">Confirmar</span>
        </b-button>
      </div>

    </b-modal>

  </Layout>
</template>

<style scoped>
.terms-container {
  max-height: 600px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f9f9f9;
}
.custom-checkbox:checked {
  background-color: #007bff;
  border-color: #007bff;
}
.custom-checkbox:checked:after {
  background-color: white;
}
</style>